import { SELECT_LOT_FOR_EDIT, UPDATE_LOT_STORE, ERASE_RU_SUB_LOTS, ERASE_LOT, ERASE_OPTIONALS } from '../types';
import store from '../../store';
import UsedRentalsAPI from '../../../API/UsedRentalsAPI';


export const selectLotForEdit = (oSelectedItem) => dispatch => {
  return dispatch({
    type: SELECT_LOT_FOR_EDIT,
    payload: oSelectedItem
  });
}

export const eraseRULotDataFromStore = () => dispatch => {
  dispatch({
    type: ERASE_LOT
  });
  dispatch({
    type: ERASE_RU_SUB_LOTS
  });
  dispatch({
    type: ERASE_OPTIONALS
  });
};


export const saveLot = () => dispatch => {
  const state = store.getState();
  const newObj = JSON.parse(JSON.stringify(state));

  let subLotList = [];

  const subLotsDictionary = {
    ...newObj.usedRentalsSubLots
  }
  // denormalizing the optionals into the DTO for persistence
  for (var key in subLotsDictionary) {
    if (subLotsDictionary.hasOwnProperty(key)) {
      if (subLotsDictionary[key].ShouldPersist === false) {
        delete subLotsDictionary[key];
        continue;
      }
      subLotsDictionary[key].SubLotCarOptionals = state.subLotCarOptionals[key];
      subLotList.push(subLotsDictionary[key]);
    }
  }

  const newIds = [];
  state.negotiationLot.SaleChannels.forEach(element => {
    newIds.push(element.value);
  });
  const negLotDTO = {
    ...state.negotiationLot,
    ListSaleChannelIds: newIds,
    SubLotList: subLotList,
  };

  const usedRentalsLotAPI = new UsedRentalsAPI();
  return usedRentalsLotAPI.editNegotiationLot(negLotDTO);
}

export const getMyOwnDataById = (state) => {
  return state.negotiationLot;
}

export const updateLotStore = (propName, propValue) => dispatch => {
  return dispatch({
    type: UPDATE_LOT_STORE,
    payload: { propName, propValue }
  });
}


// WEBPACK FOOTER //
// ./src/store/actions/RU/creationLotActions.js